import { Injectable, inject } from '@angular/core';
import { LocationsControllerService } from '@nx-customer-apps/api-planning-projects';
import { BehaviorSubject, Observable, catchError, map, of } from 'rxjs';
import { SearchDropdownItem } from '@nx-customer-apps/shared/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@nx-customer-apps/shared/services';
import { CountryCode } from '@nx-customer-apps/shared/enums';

@Injectable({
    providedIn: 'root'
})
export class PostalCodeCityService {
    private translateService = inject(TranslateService);
    private snackbarService = inject(SnackbarService);
    private locationsControllerService = inject(LocationsControllerService);

    private _countryCode$: BehaviorSubject<CountryCode> = new BehaviorSubject<CountryCode>(CountryCode.DE);

    public setCountryCode(value: CountryCode) {
        this._countryCode$.next(value);
    }

    public getPostalCodeCityAsDropdownItems(value: string): Observable<SearchDropdownItem[]> {
        const dropdownItems$ = this.locationsControllerService
            .locationsControllerGetCities({
                countryCode: this._countryCode$.value as any,
                searchString: value.trim().replace(',', '')
            })
            .pipe(
                map(response => {
                    const items = response.cities || [];
                    return items.map(cities => ({
                        value: `${cities.postalCode}, ${cities.city}`,
                        key: `${cities.postalCode} ${cities.city}`
                    }));
                }),
                catchError(() => {
                    const message = this.translateService.instant('COMMON.ERRORS.SOMETHING_WRONG');
                    const action = this.translateService.instant('COMMON.BUTTONS.GOT_IT');
                    this.snackbarService.showInfo(message, {
                        duration: 5000,
                        action
                    });
                    return of([]);
                })
            );
        return value ? dropdownItems$ : of([]);
    }
}
